import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { fetchCurrencyQueryFn } from './queryFn/fetch-currency.query';
import { fetchOfferingDiscountQueryFn } from './queryFn/fetch-offering-discount.query';
import { fetchOfferingQueryFn } from './queryFn/fetch-offering.query';
import { fetchProductQueryFn } from './queryFn/fetch-product.query';
import { fetchTaxStatusQueryFn } from './queryFn/fetch-tax-status.query';
export const StudioOfferingQueriesConfig = createQueriesConfig({
  fetchProduct: {
    queryFn: fetchProductQueryFn
  },
  fetchOffering: {
    queryFn: fetchOfferingQueryFn
  },
  fetchOfferingDiscount: {
    queryFn: fetchOfferingDiscountQueryFn
  },
  fetchTaxStatus: {
    queryFn: fetchTaxStatusQueryFn
  },
  fetchCurrency: {
    queryFn: fetchCurrencyQueryFn
  }
});
//# sourceMappingURL=studio-offering.queries.js.map